export default __webpack_public_path__ + "static/media/mmrtext.3be04b7e.ttf";